export function InitData() {

    if (!localStorage.getItem("datosm")) {
        localStorage.setItem("datosm", "");
    }
}

export function LogInCall(arraydatos) {
    localStorage.setItem("datosm", arraydatos); //se guardar los datos del login, position 0 = apikey, position 1 name user, position 2 user
}
export function LogInShare(arraydatos) {
    localStorage.setItem("sharem", arraydatos); //se guardar los datos del login, position 0 = apikey, position 1 name user, position 2 user
}

export function DelateLogin() {
    localStorage.setItem("sharem", "");
    localStorage.setItem("datosm", "");
}